import { makeAutoObservable, runInAction } from "mobx";
import { apiGet } from "../utils/fetch";
import type { SubscriptionPlanInterface, GenericResponseInterface } from "../interfaces/interfaces";

class SubscriptionPlansStore {
  subscriptionPlans: SubscriptionPlanInterface[] = [];
  loading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadSubscriptionPlans() {
    this.loading = true;
    this.error = null;
    try {
      const result = await apiGet<GenericResponseInterface<SubscriptionPlanInterface[]>>('/subscriptionPlans');
      runInAction(() => {
        if (result.status && result.data) {
          this.subscriptionPlans = result.data;
        } else {
          this.error = result.message || 'Failed to fetch subscription plans';
        }
        this.loading = false;
      });
    } catch (err: any) {
      runInAction(() => {
        this.error = err.message || 'Failed to fetch subscription plans';
        this.loading = false;
      });
    }
  }
}

const subscriptionPlansStore = new SubscriptionPlansStore();
export default subscriptionPlansStore; 
